import type { TyreVehicleKind, VehicleTyreLayout } from '@chukua/common';
import { Alert } from 'antd';
import type { useVehicleTyreActions } from '../hooks/use-vehicle-tyre-actions';
import { VehicleTyreTable } from './VehicleTyreTable';

interface RigTyreSectionProps {
  vehicleKind: TyreVehicleKind;
  layout: VehicleTyreLayout;
  actions: ReturnType<typeof useVehicleTyreActions>;
  canManage: boolean;
  selectedCode: string | null;
  onSelect: (code: string) => void;
}

/** One vehicle's positions on a rig's Tyres tab, headed with which vehicle it is: both have an `A2LO`. */
export function RigTyreSection({ vehicleKind, layout, actions, canManage, selectedCode, onSelect }: RigTyreSectionProps) {
  const noun = vehicleKind === 'truck' ? 'Truck' : 'Trailer';
  return (
    <section className="flex min-w-0 flex-col gap-2" aria-label={`${noun} ${layout.registration} tyres`}>
      <h3 className="m-0 flex flex-wrap items-baseline gap-2 text-sm font-semibold">
        <span className="text-xs tracking-wider text-muted uppercase">{noun}</span>
        <span className="font-mono">{layout.registration}</span>
        <span className="text-xs font-normal text-muted">layout {layout.layoutCode}</span>
      </h3>
      {layout.slots.some((slot) => slot.isRetired) && (
        <Alert
          type="warning"
          showIcon
          title="A position has been removed from this layout but still holds a tyre. Remove or rotate that tyre to move it onto the layout."
        />
      )}
      <VehicleTyreTable
        slots={layout.slots}
        canManage={canManage}
        selectedCode={selectedCode}
        onSelect={onSelect}
        onFit={(slot) => actions.open('fit', slot)}
        onReplace={(slot) => actions.open('replace', slot)}
        onRotate={(slot) => actions.open('rotate', slot)}
      />
    </section>
  );
}
